var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"wrapper",staticClass:"self-aware-item",style:(_vm.wrapperStyle)},[(_vm.enabled && _vm.isHidden)?_c('span',{staticClass:"self-aware-item__ghost",style:({ height: _vm.ghostHeight + 'px' })}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }